const $ = require('jquery');
import { JqueryUtil } from "../util/JqueryUtil";
import { Easing } from "../tween/Easing";

export class SimpleSlideshow {

    private $elm: JQuery;
    private duration: number;

    private $items: JQuery;
    private timer: any;
    private currentIndex: number;
    private length: number;

    constructor($elm: JQuery, duration: number = 3000) {
        this.$elm = $elm;
        this.duration = duration;

        this.init();
    }

    public start(): void {
        this.stop();
        this.timer = setInterval(() => {
            this.crossfade();
        }, this.duration);
        this.crossfade();
    }

    private crossfade(): void {
        let nextIndex: number = this.currentIndex + 1;
        if (nextIndex >= this.length) nextIndex = 0;

            const $nextItem: JQuery = this.$items.eq(nextIndex);
            JqueryUtil.fadeIn($nextItem, 300, Easing.linear, 'block', true, true);

            if (this.currentIndex >= 0) {
                const $prevItem: JQuery = this.$items.eq(this.currentIndex);
                JqueryUtil.fadeOut($prevItem, 300, Easing.linear, 'none', true, true);
            }

            this.currentIndex = nextIndex;
    }

    public stop(): void {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    private init(): void {
        this.$items = this.$elm.children();
        this.length = this.$items.length;
        this.currentIndex = -1;
    }
}